<template>
  <div class="benefits-wrapper-fi">
    <benefits-nr-fi
      class="fi-mr-18"
      :placeholder-props="placeholderProps"
      :data-source-id="dataSourceId"
    />
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { Placeholder } from '@/sitecoreState';

import BenefitsNrFi from './BenefitsNrFi.vue';
import type { PlaceholderProps } from './ProductBenefitsFi.vue';

const props = defineProps<{
  placeholderProps: PlaceholderProps;
  placeholder: Placeholder;
}>();

const dataSourceId: string = props.placeholder.dataSource || '';
</script>

<style scoped src="./benefits-wrapper-fi" />
